import { CSSProperties, ReactNode } from 'react'

interface GlassCardProps {
  children: ReactNode
  variant?: 'standard' | 'accent' | 'character' | 'dashed'
  style?: CSSProperties
  className?: string
  onClick?: () => void
  leftBorderColor?: string
  backgroundTint?: string
}

export function GlassCard({ children, variant = 'standard', style, className = '', onClick, leftBorderColor, backgroundTint }: GlassCardProps) {
  const base: CSSProperties = {
    borderRadius: variant === 'character' ? 28 : 20,
    padding: 16,
    fontFamily: 'Roboto, sans-serif',
    ...style,
  }

  if (variant === 'accent') {
    return (
      <div
        className={className}
        onClick={onClick}
        style={{
          ...base,
          background: 'linear-gradient(135deg, #1A3A5C, #4A6CF7)',
          color: 'white',
        }}
      >
        {children}
      </div>
    )
  }

  if (variant === 'character') {
    return (
      <div
        className={className}
        onClick={onClick}
        style={{
          ...base,
          background: 'radial-gradient(circle at 50% 40%, #E8F0FE, #FFFFFF)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          border: '1px solid rgba(255,255,255,0.4)',
          boxShadow: '0 8px 32px rgba(26,58,92,0.08)',
        }}
      >
        {children}
      </div>
    )
  }

  if (variant === 'dashed') {
    return (
      <div
        className={className}
        onClick={onClick}
        style={{
          ...base,
          background: 'transparent',
          border: '1.5px dashed #A0AEC0',
        }}
      >
        {children}
      </div>
    )
  }

  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        ...base,
        background: backgroundTint
          ? `${backgroundTint}, rgba(255,255,255,0.75)`
          : 'rgba(255,255,255,0.75)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        border: '1px solid rgba(255,255,255,0.4)',
        boxShadow: '0 8px 32px rgba(26,58,92,0.08)',
        borderLeft: leftBorderColor ? `3px solid ${leftBorderColor}` : undefined,
      }}
    >
      {children}
    </div>
  )
}
